import { argv0 } from 'process';

export const TicketPL = {
   pl_newly_created 		:  0,
   pl_to_be_qualified   :  5,
   pl_qualified         : 10,
   pl_scheduled         : 20,
   pl_processed         : 30,
   pl_closed            : 100
 };
 
